import { NgModule } from "@angular/core";
import { DataFilterPipe } from "./datafilter.pipe";
import { NumberWithCommasPipe } from "./number-with-commas.pipe";
import { FilterByPipe } from "./filter-by.pipe";
import { OrderByPipe } from "./order-by.pipe";

@NgModule({
    declarations: [
      DataFilterPipe,
      NumberWithCommasPipe,
      FilterByPipe,
      OrderByPipe
    ],
    imports: [
    ],
    exports: [
      DataFilterPipe,
      NumberWithCommasPipe,
      FilterByPipe,
      OrderByPipe
    ]
  })
  export class SharedPipesModule {
  }